import en_US from 'antd/es/locale/en_US';
import zh_CN from 'antd/es/locale/zh_CN';

export const locales = {
    en: { resources: 'en', moment: 'en-us', ant: en_US },
    // first day of the week is monday for locale below
    // en: {resources: 'en', moment: 'en-gb', ant: en_GB},
    zh: { resources: 'zh', moment: 'zh-cn', ant: zh_CN },
};
